export const useWindowWidth = createGlobalState(() => {
	const { width } = useWindowSize()
	const w = useDebounce(width, 150)

	const isMobile = computed(() => w.value <= 768)
	const isTablet = computed(() => w.value > 768 && w.value <= 1200)
	const isDesktop = computed(() => w.value > 1200)
	const isNotMobile = computed(() => w.value > 768)

	// widths from scss variables
	const isMobile_xs = computed(() => w.value <= 374)
	const isMobile_sm = computed(() => w.value <= 468)
	const isMobile_md = computed(() => w.value <= 568)
	const isMobile_lg = computed(() => w.value <= 768)
	const isMobile_xl = computed(() => w.value <= 876)
	const isTablet_sm = computed(() => w.value <= 1100)
	const isTablet_rg = computed(() => w.value <= 1200)
	const isTablet_lg = computed(() => w.value <= 1368)
	const isDesktop_sm = computed(() => w.value <= 1440)
	const isDesktop_md = computed(() => w.value <= 1600)
	const isDesktop_lg = computed(() => w.value > 1600)

	return {
		isMobile,
		isTablet,
		isDesktop,
		isNotMobile,
		isMobile_xs,
		isMobile_sm,
		isMobile_md,
		isMobile_lg,
		isMobile_xl,
		isTablet_sm,
		isTablet_rg,
		isTablet_lg,
		isDesktop_sm,
		isDesktop_md,
		isDesktop_lg,
	}
})
